import React, { useState } from 'react'
import {
    Box,
    Typography,
    Collapse,
    Card,
    CardContent,
    IconButton
} from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { useStyles } from './styles'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import { WifiStrengthIndicator } from 'web/src/app/root/components/common'
import Icon from '@mdi/react'
import { mdiPencilOutline } from '@mdi/js'
import { Button } from 'web/src/app/root/components/common'
import Input from 'web/src/app/root/components/common/input'
import { updateCustomerWiFiCredentials } from '../../api/device-api'
import { useMutation } from 'react-query'
import { UserPermissions } from 'web/src/services/permissions'
import { enqueueSnackbar } from 'web/src/app/root/actions'
import Clear from '@material-ui/icons/Clear'
import { TRANSFER_MODE } from 'web/src/app/root/constants'

export const DeviceAdvancedInfo = ({
    device,
    hasOccupancyRate,
    isInsectTypeTom,
    isDeviceTriggered,
    lastTriggeredDateText,
    isTrapSensor,
    isJerryBaitRat
}) => {
    const { locale, theme } = useSelector(state => state.main)
    const classes = useStyles()
    const dispatch = useDispatch()

    const [open, setOpen] = useState(true)
    const [editingSSID, setEditingSSID] = useState(false)
    const [editingPassword, setEditingPassword] = useState(false)
    const [ssid, setSSID] = useState('')
    const [isSsidError, setIsSsidError] = useState(false)
    const [password, setPassword] = useState('')
    const [isPasswordError, setIsPasswordError] = useState(false)

    const userHasPermission = UserPermissions.device().update

    const isMinLength = (value, minLength) => value.length >= minLength
    const isValidSSID = value => isMinLength(value, 1)
    const isValidPassword = value => isMinLength(value, 8)
    const isWifiTransferMode = device.transfer_mode === TRANSFER_MODE.wifi

    const { mutate: updateWiFiCredentials, isLoading } = useMutation(
        data => updateCustomerWiFiCredentials(data),
        {
            onSuccess: () => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.devices.wifiSetSuccess,
                        options: {
                            variant: 'success'
                        }
                    })
                )
            },
            onError: () => {
                dispatch(
                    enqueueSnackbar({
                        message: locale.devices.wifiSetFail,
                        options: {
                            variant: 'error'
                        }
                    })
                )
            }
        }
    )

    const handleCancelEdit = inputType => {
        if (inputType === 'ssid') {
            setEditingSSID(false)
            setSSID('')
        } else if (inputType === 'password') {
            setEditingPassword(false)
            setPassword('')
        }
    }

    const handleClick = () => {
        setOpen(!open)
    }

    const handleEditSSID = () => {
        if (userHasPermission) {
            setEditingSSID(true)
        }
    }

    const handleEditPassword = () => {
        if (userHasPermission) {
            setEditingPassword(true)
        }
    }

    const handleSaveSSID = () => {
        if (!isValidSSID(ssid)) {
            setIsSsidError(true)
            return
        }
        setIsSsidError(false)
        updateWiFiCredentials({
            customer_wifi_ssid: ssid,
            codes: [device.serial_number]
        })
        setEditingSSID(false)
    }

    const handleSavePassword = () => {
        if (!isValidPassword(password)) {
            setIsPasswordError(true)
            return
        }
        setIsPasswordError(false)
        updateWiFiCredentials({
            customer_wifi_pass: password,
            codes: [device.serial_number]
        })
        setEditingPassword(false)
    }

    return (
        <>
            <Box className={classes.advancedInformationContainer}>
                <Box
                    className={classes.advancedInformationHeadingWrapper}
                    onClick={handleClick}>
                    <Typography>{locale.common.advancedInformation}</Typography>
                    {open ? <ExpandLess /> : <ExpandMore />}
                </Box>

                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Card className={classes.deviceReportsCard}>
                        <CardContent
                            className={classes.advancedInformationCardContent}>
                            <Typography style={{ width: 200 }}>
                                {locale.devices.version}:
                            </Typography>
                            <Typography style={{ paddingLeft: 20 }}>
                                {device.version}
                            </Typography>
                        </CardContent>

                        <CardContent
                            className={classes.advancedInformationCardContent}>
                            <Typography style={{ width: 200 }}>
                                {locale.devices.deviceOperationMode}:
                            </Typography>
                            <Typography style={{ paddingLeft: 20 }}>
                                {locale.devices.operationMode[
                                    device.operation_mode
                                ] || device.operation_mode}
                            </Typography>
                        </CardContent>

                        <CardContent
                            className={classes.advancedInformationCardContent}>
                            <Typography style={{ width: 200 }}>
                                {locale.devices.deviceType}:
                            </Typography>
                            <Typography style={{ paddingLeft: 20 }}>
                                {locale.devices.deviceTypes[
                                    device.device_type
                                ] || device.device_type}
                            </Typography>
                        </CardContent>

                        {device.hasOwnProperty('transfer_mode') ? (
                            <CardContent
                                className={
                                    classes.advancedInformationCardContent
                                }>
                                <Typography style={{ width: 200 }}>
                                    {locale.devices.transferMode}:
                                </Typography>
                                <Typography style={{ paddingLeft: 20 }}>
                                    {device.transfer_mode === TRANSFER_MODE.wifi
                                        ? 'WiFi'
                                        : null}
                                    {device.transfer_mode === TRANSFER_MODE.lora
                                        ? 'LoRa'
                                        : null}
                                    {device.transfer_mode ===
                                    TRANSFER_MODE.cellular
                                        ? locale.devices.cellular
                                        : null}
                                </Typography>
                            </CardContent>
                        ) : null}

                        {!isTrapSensor ? (
                            <CardContent
                                className={
                                    classes.advancedInformationCardContent
                                }>
                                <Typography style={{ width: 200 }}>
                                    {locale.devices.macAddress}:
                                </Typography>
                                <Typography style={{ paddingLeft: 20 }}>
                                    {device.mac_address}
                                </Typography>
                            </CardContent>
                        ) : null}

                        <CardContent
                            className={classes.advancedInformationCardContent}>
                            <Typography style={{ width: 200 }}>
                                {locale.devices.heartbeatCount}:
                            </Typography>
                            <Typography style={{ paddingLeft: 20 }}>
                                {device.heartbeat_count || 0}
                            </Typography>
                        </CardContent>
                        {isJerryBaitRat ? (
                            <>
                                <CardContent
                                    className={
                                        classes.advancedInformationCardContent
                                    }>
                                    <Typography style={{ width: 200 }}>
                                        {locale.devices.baitLowCount}:
                                    </Typography>
                                    <Typography style={{ paddingLeft: 20 }}>
                                        {device.bait_low_count}
                                    </Typography>
                                </CardContent>
                                <CardContent
                                    className={
                                        classes.advancedInformationCardContent
                                    }>
                                    <Typography style={{ width: 200 }}>
                                        {locale.devices.activityCount}:
                                    </Typography>
                                    <Typography style={{ paddingLeft: 20 }}>
                                        {device.bait_pad_activity_count}
                                    </Typography>
                                </CardContent>
                            </>
                        ) : null}

                        {hasOccupancyRate && (
                            <CardContent
                                className={
                                    classes.advancedInformationCardContent
                                }>
                                <Typography style={{ width: 200 }}>
                                    {locale.devices.occupancyRate}:
                                </Typography>
                                <Typography style={{ paddingLeft: 20 }}>
                                    {device.data?.TOM?.occupancy_rate
                                        ? `${device.data?.TOM?.occupancy_rate}%`
                                        : 'N/A'}
                                </Typography>
                            </CardContent>
                        )}

                        {isInsectTypeTom && (
                            <>
                                <CardContent
                                    className={
                                        classes.advancedInformationCardContent
                                    }>
                                    <Typography style={{ width: 200 }}>
                                        {locale.devices.triggerCount}:
                                    </Typography>
                                    <Typography style={{ paddingLeft: 20 }}>
                                        {device.triggered_count || 0}
                                    </Typography>
                                </CardContent>

                                <CardContent
                                    className={
                                        classes.advancedInformationCardContent
                                    }>
                                    <Typography style={{ width: 200 }}>
                                        {locale.devices.catchCount}:
                                    </Typography>
                                    <Typography style={{ paddingLeft: 20 }}>
                                        {device.confirmed_count || 0}
                                    </Typography>
                                </CardContent>

                                {isDeviceTriggered && (
                                    <CardContent
                                        className={
                                            classes.advancedInformationCardContent
                                        }>
                                        <Typography style={{ width: 200 }}>
                                            {locale.devices.triggeredSince}:
                                        </Typography>
                                        <Typography style={{ paddingLeft: 20 }}>
                                            {lastTriggeredDateText()}
                                        </Typography>
                                    </CardContent>
                                )}
                            </>
                        )}

                        <CardContent
                            className={classes.advancedInformationCardContent}>
                            <Typography style={{ width: 200 }}>
                                {locale.devices.wifiSignalStrength}:
                            </Typography>
                            <div
                                style={{
                                    paddingLeft: 20
                                }}>
                                <WifiStrengthIndicator
                                    locale={locale}
                                    theme={theme}
                                    device={device}
                                />
                            </div>
                        </CardContent>
                        {isWifiTransferMode && !isTrapSensor ? (
                            <>
                                <CardContent
                                    className={
                                        classes.advancedInformationCardContent
                                    }>
                                    <Typography
                                        style={{
                                            width: 200,
                                            overflow: 'visible'
                                        }}>
                                        {locale.devices.wifiSSID}:
                                    </Typography>
                                    {editingSSID ? (
                                        <>
                                            <Typography
                                                style={{
                                                    paddingLeft: 20,
                                                    maxWidth: '40vw',
                                                    flex: 1
                                                }}>
                                                <Input
                                                    errorInsteadOfLabel={true}
                                                    size="small"
                                                    label={
                                                        locale.devices.wifiSSID
                                                    }
                                                    type="text"
                                                    value={ssid}
                                                    isError={isSsidError}
                                                    errorText={
                                                        locale.devices
                                                            .wifiSSIDMinLengthError
                                                    }
                                                    setValue={setSSID}
                                                    endIcon={() =>
                                                        userHasPermission ? (
                                                            <IconButton
                                                                size="small"
                                                                onClick={() =>
                                                                    handleCancelEdit(
                                                                        'ssid'
                                                                    )
                                                                }
                                                                classes={{
                                                                    root: classes.searchClearIcon
                                                                }}>
                                                                <Clear />
                                                            </IconButton>
                                                        ) : null
                                                    }
                                                />
                                            </Typography>
                                            {userHasPermission && (
                                                <Button
                                                    style={{
                                                        marginBottom: 6,
                                                        height: 39
                                                    }}
                                                    className={classes.button}
                                                    onClick={handleSaveSSID}>
                                                    {locale.common.save}
                                                </Button>
                                            )}
                                        </>
                                    ) : (
                                        <Typography
                                            style={{
                                                paddingLeft: 20,
                                                maxWidth: '40vw',
                                                flex: 1
                                            }}>
                                            ***
                                            {userHasPermission && (
                                                <IconButton
                                                    size="small"
                                                    onClick={handleEditSSID}>
                                                    <Icon
                                                        path={mdiPencilOutline}
                                                        size={1}
                                                        style={{
                                                            margin: 0
                                                        }}
                                                    />
                                                </IconButton>
                                            )}
                                        </Typography>
                                    )}
                                </CardContent>

                                <CardContent
                                    className={
                                        classes.advancedInformationCardContent
                                    }>
                                    <Typography
                                        style={{
                                            width: 200,
                                            overflow: 'visible'
                                        }}>
                                        {locale.devices.wifiPassword}:
                                    </Typography>
                                    {editingPassword ? (
                                        <>
                                            <Typography
                                                style={{
                                                    paddingLeft: 20,
                                                    maxWidth: '40vw',
                                                    flex: 1
                                                }}>
                                                <Input
                                                    errorInsteadOfLabel={true}
                                                    label={
                                                        locale.devices
                                                            .wifiPassword
                                                    }
                                                    size="small"
                                                    value={password}
                                                    setValue={setPassword}
                                                    type="text"
                                                    isError={isPasswordError}
                                                    errorText={
                                                        password
                                                            ? locale.devices
                                                                  .wifiPasswordMinLengthError
                                                            : locale.devices
                                                                  .wifiSSIDMinLengthError
                                                    }
                                                    endIcon={() =>
                                                        userHasPermission ? (
                                                            <IconButton
                                                                size="small"
                                                                onClick={() =>
                                                                    handleCancelEdit(
                                                                        'password'
                                                                    )
                                                                }
                                                                classes={{
                                                                    root: classes.searchClearIcon
                                                                }}>
                                                                <Clear />
                                                            </IconButton>
                                                        ) : null
                                                    }
                                                />
                                            </Typography>
                                            {userHasPermission && (
                                                <Button
                                                    style={{
                                                        marginBottom: 6,
                                                        height: 39
                                                    }}
                                                    onClick={
                                                        handleSavePassword
                                                    }>
                                                    {locale.common.save}
                                                </Button>
                                            )}
                                        </>
                                    ) : (
                                        <Typography
                                            style={{
                                                paddingLeft: 20,
                                                maxWidth: '40vw',
                                                flex: 1
                                            }}>
                                            ***
                                            {userHasPermission && (
                                                <IconButton
                                                    size="small"
                                                    onClick={
                                                        handleEditPassword
                                                    }>
                                                    <Icon
                                                        path={mdiPencilOutline}
                                                        size={1}
                                                        style={{
                                                            margin: 0
                                                        }}
                                                    />
                                                </IconButton>
                                            )}
                                        </Typography>
                                    )}
                                </CardContent>
                            </>
                        ) : null}
                    </Card>
                </Collapse>
            </Box>
        </>
    )
}
